import React from 'react';
import classNames from 'classnames';
export const Table = ({ children, containerClassName, tableClassName, }) => (React.createElement("div", { className: classNames('table-container', containerClassName) },
    React.createElement("table", { className: classNames('table', tableClassName) }, children)));
